import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

import { HeaderActionButton } from './header-action-buttons.model';

/**
 * Component: HeaderActionButtonsComponent
 */
@Component({
  selector: 'header-action-buttons',
  templateUrl: './header-action-buttons.component.html',
  styleUrls: ['./header-action-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderActionButtonsComponent {
  @Input()
  public buttons: HeaderActionButton[] = [];
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;
}
